import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import Firebase from './firebase.js';

const auth = Firebase.auth;

import {store} from "./store";

Vue.config.productionTip = false

Vue.prototype.$analytics = Firebase.fbAnalytics;

Vue.use(require('vue-moment'));

Vue.filter('ucwords', function (value) {
  if (!value) return ''
  value = value.toString().toLowerCase()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

let app
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  if (user) {
    store.dispatch('loadUserData', user)
  }
})

